jQuery(
	function ($) {
		$(document).ready(function () {
			if ($("#top-header .menu-event-menu-container, #top-header .upcoming-events-container").prop('scrollWidth') - 16 > $("#top-header .menu-event-menu-container, #top-header .upcoming-events-container").width()) {
			  //console.log("overflowing");
			  //console.log("scrollWidth: " + $("#top-header .menu-event-menu-container, #top-header .upcoming-events-container").prop('scrollWidth'));
			  //console.log("width: " + $("#top-header .menu-event-menu-container, #top-header .upcoming-events-container").width());
			  $('#top-header .menu-slide-btn').removeClass("hidden");
			} else {
			  //console.log("not overflowing");
			  if (!$('#top-header .menu-slide-btn').hasClass("hidden")) {
				$('#top-header .menu-slide-btn').addClass("hidden");
			  }
			}
			$('#top-header #slideNext').click(function (e) {
			  //console.log("Scroll right");
			  $('#top-header .menu-event-menu-container, #top-header .upcoming-events-container').animate({
				'scrollLeft': '+=300px'
			  });
			});
			$('#top-header #slideBack').click(function (e) {
			  //console.log("Scroll left");
			  $('#top-header .menu-event-menu-container, #top-header .upcoming-events-container').animate({
				'scrollLeft': '-=300px'
			  });
			});
		  });
		  $(window).resize(function () {
			if ($("#top-header .menu-event-menu-container, #top-header .upcoming-events-container").prop('scrollWidth') - 16 > $("#top-header .menu-event-menu-container, #top-header .upcoming-events-container").width()) {
			  //console.log("overflowing");
			  $('#top-header .menu-slide-btn').removeClass("hidden");
			} else {
			  //console.log("not overflowing");
			  if (!$('#top-header .menu-slide-btn').hasClass("hidden")) {
				$('#top-header .menu-slide-btn').addClass("hidden");
			  }
			}
		  });
	}
);
